import React from 'react';
import { cn } from '@/lib/utils';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  className?: string;
}

const predefinedColors = [
  '#3b82f6', // blue
  '#ef4444', // red
  '#10b981', // green
  '#FFC107', // marca
  '#8b5cf6', // purple
  '#06b6d4', // cyan
  '#f97316', // orange
  '#ec4899', // pink
  '#84cc16', // lime
  '#6366f1', // indigo
];

export const ColorPicker: React.FC<ColorPickerProps> = ({ value, onChange, className }) => {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {predefinedColors.map((color) => (
        <button
          key={color}
          type="button"
          className={cn(
            'w-8 h-8 rounded-full border-2 transition-all hover:scale-110',
            value === color ? 'border-gray-800 scale-110' : 'border-gray-300'
          )}
          style={{ backgroundColor: color }}
          onClick={() => onChange(color)}
          title={color}
        />
      ))}
      <div className="relative">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-8 h-8 rounded-full border-2 border-gray-300 cursor-pointer"
          title="Cor personalizada"
        />
      </div>
    </div>
  );
};
